import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
  Tooltip,
  makeStyles,
  IconButton,
} from "@material-ui/core";

import PropTypes from "prop-types";

import { AfiliadoMenu } from "./Menus/AfiliadoMenu";
import { AdministrarMenu } from "./Menus/AdministrarMenu";
import { InformacionMenu } from "./Menus/InformacionMenu";
import { PracticasMenu } from "./Menus/PracticasMenu";
import { NotasMenu } from "./Menus/NotasMenu";
import { ObservacionesMenu } from "./Menus/ObservacionesMenu";
import { clearSolicitudYPracticas, getSeguimientoSolicitud, putLiberarSolicitud } from "../../../actions/autorizaciones/Autorizaciones";
import {
  AUTORIZACIONES_BANDEJAS,
  AUTORIZACIONES_COBRA_COSEGURO,
  AUTORIZACIONES_MENU_AUDITORIA,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  // AUTORIZACIONES_BANDEJAS,
  TIPOS_AUTORIZACIONES,
} from "../../../utils/constants";
import { MonetizationOn, NoEncryption, Print } from "@material-ui/icons";
import { ModalPagoCoseguro } from "./ModalPagoCoseguro";
import AutorizacionesCoseguroImpresion from "../Ingreso/AutorizacionesCoseguroImpresion";
import { ModalInformacionPago } from "./ModalInformacionPago";
import { PracticasDenunciaMenu } from './Menus/PracticasDenunciaMenu';
import { PracticasDenunciaPendientesMenu } from './Menus/PracticasDenunciaPendientesMenu';
import { SolicitudesRelacionadasMenu } from "./Menus/SolicitudesRelacionadasMenu";
import { AUTORIZACIONES_PERMISOS } from '../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { EfectorLaboratorio } from './Menus/EfectorLaboratorio';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  iconInfo: {
    fontSize: 16,
  },
}));

export const ModalAuditar = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState(
    AUTORIZACIONES_MENU_AUDITORIA.AFILIADO
  );
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const [openModalPago, setOpenModalPago] = useState(false);
  const [openModalInfoPago, setOpenModalInfoPago] = useState(false);
  const [openOpcionesSolicitud, setOpenOpcionesSolicitud] = useState(false);

  const { solicitudSeleccionada = {}, estadoSolicitudes } = useSelector(
    (state) => state.autorizaciones
  );

  const esDenunciaInternacion = solicitudSeleccionada?.idTipoSolicitud ===
    TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION;

  const esDenunciaInternacionDomiciliaria = solicitudSeleccionada?.idTipoSolicitud ===
    TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA;

  const esPasajesOEstadias = solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES ||
    solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS;


  const { open } = props;

  useEffect(() => {
    setSelectedTab(AUTORIZACIONES_MENU_AUDITORIA.AFILIADO);
    if (esDenunciaInternacion)
      dispatch(getSeguimientoSolicitud(solicitudSeleccionada?.idSolicitud));
  }, [open, solicitudSeleccionada?.idSolicitud]);

  useEffect(() => {
    return () => {
      dispatch(clearSolicitudYPracticas());
    };
  }, []);

  const disabled = solicitudSeleccionada?.idEstadoSolicitud ===
    AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA || props.disabled;

  const disabledAuditar = !validarSoloUnPermiso(permisosUser, AUTORIZACIONES_PERMISOS.AUDITAR_SOLICITUDES)
  //|| solicitudSeleccionada?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE;

  return (
    <Dialog
      fullWidth
      //maxWidth="md"
      maxWidth="lg"
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>
        {openModalPago &&
          <ModalPagoCoseguro
            open={openModalPago}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            closeModalHandler={() => setOpenModalPago(false)}
            handleCloseModalCoseguroImpresion={props.closeModalHandler}
            importeCoseguros={solicitudSeleccionada.importeCobrarCoseguro}
            filtros={props.filtros}
          />
        }
        {openOpcionesSolicitud &&
          <AutorizacionesCoseguroImpresion
            open={openOpcionesSolicitud}
            closeModalHandler={() => setOpenOpcionesSolicitud(false)}
            periodos={
              Array.from(
                new Set(
                  solicitudSeleccionada?.practicas
                    ?.filter(p => p.periodos?.length > 0)
                    .flatMap(p => p.periodos.filter(a => a.periodo).map(a => a.periodo))
                )
              )
            }
            esDenunciaInternacionDomiciliaria={esDenunciaInternacionDomiciliaria}
            filtros={props.filtros}
          />
        }
        {openModalInfoPago &&
          <ModalInformacionPago
            open={openModalInfoPago}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            closeModalHandler={() => setOpenModalInfoPago(false)}
            items={solicitudSeleccionada.practicas
              .filter(s => s.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB && s.pagoCoseguro)
            }
            filtros={props.filtros}
          />
        }
        <span style={{ float: 'left' }}>Resumen de la Orden de Autorización Nº{solicitudSeleccionada?.idSolicitud}</span>
        {(parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.CANCELADA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA
          && parseInt(estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA) &&
          solicitudSeleccionada?.solicitudesTomadas?.length > 0 && !disabled &&
          <Tooltip
            title={
              <>
                <span sx={{
                  fontSize: 16,
                }}>
                  {`Liberar Solicitud`}
                </span>
              </>
            }
          >
            <IconButton
              style={{ float: 'right', padding: 0 }}
              color="inherit"
              onClick={() => {
                dispatch(
                  putLiberarSolicitud(
                    { id: solicitudSeleccionada?.solicitudesTomadas[0].id, idSolicitud: solicitudSeleccionada?.idSolicitud },
                    'currentUser',
                    false,
                    null,
                    null,
                    props.closeModalHandler,
                    null,
                    null,
                    false,
                    props.filtros
                  )
                );
              }}
            >
              <NoEncryption />
            </IconButton>
          </Tooltip>
        }
        {parseInt(estadoSolicitudes) ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_COSEGURO && solicitudSeleccionada?.fechaBaja === null &&
          <Tooltip
            title={
              <>
                <span className={classes.iconInfo}>
                  {`Abonar Coseguro`}
                </span>
              </>
            }
          >
            <IconButton
              style={{ float: 'right', padding: 0 }}
              color="inherit"
              onClick={() => {
                setOpenModalPago(true);
              }}
            >
              <MonetizationOn />
            </IconButton>
          </Tooltip>
        }
        {(parseInt(estadoSolicitudes) ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA
          || parseInt(estadoSolicitudes) ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
          || esDenunciaInternacionDomiciliaria)
          && solicitudSeleccionada?.fechaBaja === null &&
          <div>
            <Tooltip
              title={
                <>
                  <span className={classes.iconInfo}>
                    {`Imprimir Autorización`}
                  </span>
                </>
              }
            >
              <IconButton
                style={{ float: 'right', padding: 0, marginLeft: 15 }}
                color="inherit"
                onClick={() => {
                  setOpenOpcionesSolicitud(true);
                }}
              >
                <Print />
              </IconButton>
            </Tooltip>
            {solicitudSeleccionada?.practicas
              .filter(s => s.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB)
              .length > 0 &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {`Información pago`}
                    </span>
                  </>
                }
              >
                <IconButton
                  style={{ float: 'right', padding: 0 }}
                  color="inherit"
                  onClick={() => {
                    setOpenModalInfoPago(true);
                  }}
                >
                  <MonetizationOn />
                </IconButton>
              </Tooltip>
            }
          </div>
        }
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.AFILIADO}
            label="Afiliado"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.AFILIADO)}
          />
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.INFORMACION}
            label="Información"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.INFORMACION)}
          />
          {solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.EFECTOR_LABORATORIO}
              label="Efector Laboratorio"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.EFECTOR_LABORATORIO)}
            />
          }
          {!esPasajesOEstadias && <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS}
            label={!esDenunciaInternacion ? "Practicas" : "Practicas Autorizadas"}
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS)}
          />}
          {esDenunciaInternacion &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.OBSERVACIONES}
              label="Observaciones"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.OBSERVACIONES)}
            />
          }
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.NOTAS}
            label="Notas"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.NOTAS)}
          />
          {esDenunciaInternacion &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS_PENDIENTES}
              label="Practicas Pendientes"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS_PENDIENTES)}
            />
          }
          {esDenunciaInternacion &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.SOLICITUDES_REL}
              label="Solicitudes Relacionadas"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.SOLICITUDES_REL)}
            />
          }
          {!esDenunciaInternacion && !disabled && !disabledAuditar /*&& solicitudSeleccionada?.idTipoSolicitud !==
            TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA*/ &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR}
              label="Administrar"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR)}
            />
          }
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.AFILIADO}
        >
          <AfiliadoMenu
            solicitud={true}
            afiliado={solicitudSeleccionada?.afiliado}
            idMotivoInternacion={solicitudSeleccionada?.idMotivoInternacion}
            filtros={props.filtros}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.INFORMACION}
        >
          <InformacionMenu
            onCloseModalAuditar={props.closeModalHandler}
            disabled={disabled || solicitudSeleccionada?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE ||
              solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AFILIACIONES
            }
            filtros={props.filtros}
            seguimiento={props.seguimiento}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.EFECTOR_LABORATORIO}
        >
          <EfectorLaboratorio
            disabled={disabled}
            filtros={props.filtros}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS}
        >
          {!esDenunciaInternacion
            ?
            <PracticasMenu
              disabled={disabled || solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AFILIACIONES}
              permisoIngresoInterDom={props.permisoIngresoInterDom}
              onCloseModalAuditar={props.closeModalHandler}
              esDenunciaInternacion={esDenunciaInternacion}
              disabledAuditar={disabledAuditar}
              seguimiento={props.seguimiento}
              filtros={props.filtros}
            />
            :
            <PracticasDenunciaMenu
              disabled={true}
              filtros={props.filtros}
              onCloseModalAuditar={props.closeModalHandler}
              seguimiento={props.seguimiento}
            />
          }
        </TabPanel>
        {esDenunciaInternacion &&
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS_PENDIENTES}
          >
            <PracticasDenunciaPendientesMenu
              disabled={disabled || solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AFILIACIONES}
              filtros={props.filtros}
              onCloseModalAuditar={props.closeModalHandler}
              seguimiento={props.seguimiento}
            />
          </TabPanel>
        }
        {esDenunciaInternacion &&
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_MENU_AUDITORIA.OBSERVACIONES}
          >
            <ObservacionesMenu
              disabled={disabled
                && props.filtros?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO}
              filtros={props.filtros} />
          </TabPanel>
        }
        {esDenunciaInternacion &&
          <TabPanel
            value={selectedTab}
            index={AUTORIZACIONES_MENU_AUDITORIA.SOLICITUDES_REL}
          >
            <SolicitudesRelacionadasMenu
              disabled={disabled || solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AFILIACIONES}
              filtros={props.filtros}
              onCloseModalAuditar={props.closeModalHandler}
              seguimiento={props.seguimiento}
            />
          </TabPanel>
        }
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.NOTAS}
        >
          <NotasMenu
            disabled={disabled}
            filtros={props.filtros} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR}
        >
          <AdministrarMenu
            closeModalAuditar={props.closeModalHandler}
            filtros={props.filtros}
            setRedirect={props.setRedirect}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
